import { Box, Typography } from "@mui/material"
import { MiniGalery } from "components/MiniGalery.tsx/MiniGalery"
import { ReportNodeImageBox } from "components/ReportNodeImage/ReportNodeImageBox"
import { ReportNodeTableBox } from "components/ReportNodeTable/ReportNodeTableBox"
import { ReportNodeTextBox } from "components/ReportNodeText/ReportNodeTextBox"
import { Examination, TestData } from "graphql/types"
import { isNodeImage, isNodeTable, isNodeText } from "store/typeGuards"

type TaskTestConfigurationCardProps = {
  testData: TestData
  examination: Examination
}

export const TaskTestConfigurationCard = (props: TaskTestConfigurationCardProps) => {
  const { testData, examination } = props

  return (
    <>
      {examination.testParameterBlock.map((item) => (
        <Box key={item.name}>
          {item.block.map((item) => (
            <Box key={item.id}>
              {isNodeText(item) && <ReportNodeTextBox data={item} />}
              {isNodeTable(item) && <ReportNodeTableBox data={item} />}
              {isNodeImage(item) && <ReportNodeImageBox data={item} />}
            </Box>
          ))}
        </Box>
      ))}

      <MiniGalery images={testData.image} deleteButton={false} />
      <Typography variant="body2">Anmerkung:</Typography>
      <Typography variant="body2">{testData.description}</Typography>
    </>
  )
}
